import { RepeatIntervalType, SkipType } from './rule-config';

export const convertSkipCountToSkipType = (skipPosition: number): SkipType => {
  if (!skipPosition && skipPosition !== 0) {
    return 'default';
  }
  if (skipPosition > 0) {
    return 'skip';
  }
  return 'no_skip';
};

export const convertPeriodLengthToRepeatIntervalDay = (periodLength: number): number => {
  return Math.floor(periodLength / 1440);
};

export const convertPeriodLengthToRepeatIntervalHour = (periodLength: number): number => {
  const minutes = periodLength % 60;
  const days = Math.floor(periodLength / 1440);
  return (periodLength - days * 1440 - minutes) / 60;
};

export const convertPeriodLengthToRepeatIntervalMinute = (periodLength: number): number => {
  return periodLength % 60;
};

export const convertPeriodLengthToRepeatIntervalType = (
  periodLength: number,
): RepeatIntervalType => {
  if (periodLength === 60 * 24) {
    return 'daily';
  }
  if (periodLength === 60 * 24 * 7) {
    return 'weekly';
  }
  return 'advanced';
};
